<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $t('messages.dashboard'),
                        href: meta.links.dashboard_index,
                    },
                    {
                        name: $t('messages.custom_school_annotations'),
                        href: null,
                    },
                ]"
            />
        </template>

        <div class="w-full flex space-x-4 justify-end">
            <SingleTextModalForm :endpoint="meta.endpoints.create_section" :button-text="$t('messages.create')" />
        </div>

        <EmptyState picture v-if="studentFileCustomSections.length === 0" />

        <div class="mt-5" v-for="(section, index) in studentFileCustomSections" :key="section.id">
            <div>
                <div class="flex justify-between">
                    <span class="font-semibold">
                        {{ index + 1 }} -
                        {{ section.name }}
                    </span>
                    <div class="flex justify-end gap-x-1 items-center">
                        <SingleTextModalForm
                            :button-text="$t('messages.edit')"
                            :endpoint="section.edit_endpoint"
                            :text="section.name"
                            is-edit
                            use-square-button
                        />
                        <InertiaSquareDeleteButton :href="section.links.delete" />
                    </div>
                </div>
                <div class="bg-gray-100 overflow-hidden rounded-lg mt-3">
                    <div class="px-4 py-5 sm:p-6">
                        <div class="flex flex-col mt-5">
                            <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
                                <div
                                    class="align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200"
                                >
                                    <table class="min-w-full divide-y divide-gray-200">
                                        <thead>
                                            <tr>
                                                <th
                                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 tracking-wider"
                                                >
                                                    {{ $tc('messages.fields', 1) }}
                                                </th>
                                                <th
                                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                                >
                                                    {{ $tc('messages.options', 2) }}
                                                </th>
                                                <th
                                                    class="max-w-xs px-6 py-3 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider"
                                                >
                                                    <span class="sr-only">{{ $t('messages.actions') }}</span>
                                                </th>
                                            </tr>
                                            <tr
                                                :class="'bg-white'"
                                                v-for="field in section.fields"
                                                :key="`${field.id}_${field.updated_at}`"
                                            >
                                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                                    {{ field.name }}
                                                </td>
                                                <td class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500">
                                                    {{ field.option_texts }}
                                                </td>
                                                <td
                                                    class="px-6 py-4 whitespace-nowrap text-sm leading-5 text-gray-500 flex justify-end space-x-1 items-center"
                                                >
                                                    <StudentFileFieldEditModalForm :field="field" />
                                                    <InertiaSquareDeleteButton :href="field.links.delete" />
                                                </td>
                                            </tr>
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="px-4 py-5 sm:p-6">
                        <StudentFileFieldCreateModalForm :endpoint="section.field_create_endpoint" />
                    </div>
                </div>
            </div>
        </div>

        <template v-slot:pagination>
            <InertiaPagination :paginator="studentFileCustomSections" />
        </template>
    </PanelPage>
</template>

<script>
import AdminLayout from '@/Shared/AdminLayout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import InertiaPagination from '@/Shared/InertiaPagination.vue';
import EmptyState from '@/components/EmptyState.vue';
import SingleTextModalForm from '@/components/pageSpecific/SingleTextModalForm.vue';
import StudentFileFieldCreateModalForm from '@/components/pageSpecific/StudentFileFieldCreateModalForm.vue';
import InertiaSquareDeleteButton from '@/components/InertiaSquareDeleteButton.vue';
import StudentFileFieldEditModalForm from '@/components/pageSpecific/StudentFileFieldEditModalForm.vue';

export default {
    components: {
        PanelPage,
        InertiaPagination,
        EmptyState,
        SingleTextModalForm,
        StudentFileFieldCreateModalForm,
        StudentFileFieldEditModalForm,
        InertiaSquareDeleteButton,
    },
    layout: AdminLayout,
    name: 'Index',
    props: ['meta', 'studentFileCustomSections', 'filters', 'options'],
};
</script>
